var _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -403.546,
    y1: -337.031,
    x2: -403.376,
    y2: -337.031,
    gradientTransform: "matrix(96.894, -151.7, -151.7, -96.894, -12016.61, -93843.838)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -403.546,
    y1: -337.033,
    x2: -403.376,
    y2: -337.033,
    gradientTransform: "matrix(96.894, -151.7, -151.7, -96.894, -12016.61, -93843.838)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -403.546,
    y1: -336.987,
    x2: -403.376,
    y2: -336.987,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -405.673,
    y1: -336.64,
    x2: -405.503,
    y2: -336.64,
    gradientTransform: "matrix(-54.933, -55.519, -55.519, 54.933, -40949.55, -4004.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f2f2"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_eps") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "24.037 2.072 24.034 2.072 29.598 7.873 29.598 29.928 8.814 29.928 8.814 30 29.67 30 29.67 7.945 24.037 2.072",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.893,7.945V2.072l5.633,5.873H23.893M23.965,2H8.742V3.432H22.461v6.832H8.742V29.928H29.6V7.873l-5.564-5.8L23.965,2",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "23.893 2.072 23.893 7.945 29.526 7.945 23.893 2.072",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.965 2 23.965 7.873 29.598 7.873 23.965 2",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "8.742 3.432 2.384 3.432 2.384 10.264 8.742 10.264 8.742 3.432",
    style: {
      fill: "#949494"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22.461 3.432 8.742 3.432 8.742 10.264 22.461 10.264 22.461 3.432",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.33,
    y: 3.378,
    width: 20.077,
    height: 6.832,
    style: {
      fill: "#030100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.003 7.309 8.779 7.309 8.779 8.143 10.15 8.143 10.15 9.138 7.863 9.138 7.863 4.605 10.079 4.605 10.079 5.594 8.779 5.594 8.779 6.327 10.003 6.327 10.003 7.309",
    style: {
      fill: "#fe7814"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.163,4.666a5.451,5.451,0,0,1,1.129-.094,1.432,1.432,0,0,1,1.078.356,1.557,1.557,0,0,1,.39,1.1,1.767,1.767,0,0,1-.329,1.116,1.422,1.422,0,0,1-1.139.471,1.893,1.893,0,0,1-.223-.014v1.54h-.906Zm.906,2a1.463,1.463,0,0,0,.207.014.564.564,0,0,0,.582-.632.5.5,0,0,0-.516-.565,1.06,1.06,0,0,0-.273.027Z",
    style: {
      fill: "#fe7814"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.777,7.928a1.676,1.676,0,0,0,.886.283c.314,0,.466-.141.466-.37s-.152-.35-.536-.525a1.448,1.448,0,0,1-.957-1.365A1.321,1.321,0,0,1,16,4.531a1.748,1.748,0,0,1,.926.235l-.192.968a1.431,1.431,0,0,0-.744-.215c-.278,0-.43.135-.43.336,0,.229.182.323.612.538a1.4,1.4,0,0,1,.891,1.365,1.357,1.357,0,0,1-1.458,1.453,1.924,1.924,0,0,1-1-.283Z",
    style: {
      fill: "#fe7814"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.608,17.582S18,13.3,22.167,17.432s.18,9.739.18,9.739Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.42,27.223l-.147-.1c.039-.055,3.892-5.59-.17-9.623s-9.387.114-9.44.156l-.112-.141c.055-.043,5.5-4.287,9.678-.143S22.46,27.167,22.42,27.223Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.04,
    y: 11.447,
    width: 0.18,
    height: 11.866,
    transform: "translate(-5.802 20.788) rotate(-45.103)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.792,
    y: 17.058,
    width: 0.749,
    height: 0.749,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.692,17.958H21.641V16.907h1.051Zm-.749-.3h.447v-.447h-.447Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.233,
    y: 17.208,
    width: 0.749,
    height: 0.749,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.133,18.108H12.082V17.057h1.051Zm-.749-.3h.447v-.447h-.447Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.972,
    y: 26.797,
    width: 0.749,
    height: 0.749,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.872,27.7H21.821V26.646h1.051Zm-.749-.3h.447v-.447h-.447Z",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.552,
    y: 12.818,
    width: 0.749,
    height: 0.749,
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.958,
    y: 21.193,
    width: 0.749,
    height: 0.749,
    style: {
      fill: "#999"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEps);
export default __webpack_public_path__ + "static/media/eps.92ecfb416e9ee0ce22954d7a547aa485.svg";
export { ForwardRef as ReactComponent };